/* @flow */
import React, { memo, useEffect, useState } from 'react';
import { StandardTable } from '@/components';
import Papa from 'papaparse';
import { Alert, Spin } from 'antd';

type Props = {
  fileUrl: string,
};

const CSVViewer = ({ fileUrl }: Props) => {
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleDataChange = (file) => {
      setData(file.data);
      setLoading(false);
      setColumns(makeColumns(file.meta.fields));
    };

    const parseFile = async () => {
      try {
        await Papa.parse(fileUrl, {
          download: true,
          header: true,
          dynamicTyping: true,
          error: (error) => {
            setError(error);
            setLoading(false);
          },
          complete: handleDataChange,
        });
        setError(null);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };

    parseFile();
  }, [fileUrl]);

  const makeColumns = (rawColumns) => {
    return rawColumns.map((column) => {
      return { title: column, dataIndex: column, key: column };
    });
  };

  const paginationProps = {
    total: data.length,
    defaultPageSize: 100,
    pageSizeOptions: ['100', '200', '500'],
    showSizeChanger: true,
    showQuickJumper: true,
  };

  const renderTableContent = () => {
    if (!error) {
      if (loading) {
        return <Spin />;
      } else {
        return (
          <StandardTable scroll={{ x: true }} bordered pagination={paginationProps} data={data} columns={columns} />
        );
      }
    } else {
      return <Alert message="Error" description="Some error has occurred. Please try again." type="error" showIcon />;
    }
  };

  return <div>{renderTableContent()}</div>;
};

const CSVViewerMemo = memo<Props>(CSVViewer);

export default CSVViewerMemo;
